import React from 'react';

const FullscreenComponent = () => {
	const handleFullscreen = () => {
		const element = document.documentElement; // or use a specific element

		if (element.requestFullscreen) {
			element.requestFullscreen();
		} else if (element.mozRequestFullScreen) {
			// Firefox
			element.mozRequestFullScreen();
		} else if (element.webkitRequestFullscreen) {
			// Chrome, Safari, and Opera
			element.webkitRequestFullscreen();
		} else if (element.msRequestFullscreen) {
			// IE/Edge
			element.msRequestFullscreen();
		}
	};

	return (
		<div className="btns-fs">
			<button onClick={handleFullscreen}>Go Fullscreen</button>
		</div>
	);
};

export default FullscreenComponent;
